// @mui material components
import {
  Alert,
  Card,
  Grid,
  LinearProgress,
  Snackbar,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";
import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
// Material Dashboard 2 React example components
import Footer from "components/Footer";
import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
// Dashboard components
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import MDTypography from "components/MDTypography";
import PieChart from "components/PieChart";
import { setHomePage, useMaterialUIController } from "context";
import dayjs from "dayjs";
import useAuth from "hooks/useAuth";
import { useSetRecoilState } from "recoil";
import { AlertState } from "states";
import CardInforDoc from "../../components/CardInforDoc/cardInforDoc";
import DefaultInfoCard from "../../components/DefaultInfoCard";
import VerticalBarChart from "../../components/VerticalBarChart";
import {
  API_ROUTES,
  ID_GROUP_CAPTINH,
  PermissionMenuKey,
} from "../../utils/constants";
import { JsonTool } from "../../utils/jsonTools";
import DataTable from "components/DataTable";
import { CountNotificationState } from "states";
import {
  ID_GROUP_HOIDONG,
  ID_GROUP_CHUTHE,
  ID_GROUP_NUMBER_SEVEN,
  ID_GROUP_PHUONGXA,
  ID_GROUP_NUMBER_ONE,
} from "../../utils/constants";

const colorDefault = ["info", "success", "secondary", "error", "warning"];
function LinearProgressWithLabel(props) {
  return (
    <MDBox sx={{ display: "flex", alignItems: "center" }}>
      <MDBox sx={{ width: "100%", mr: 1 }}>
        <LinearProgress variant="determinate" {...props} />
      </MDBox>
      <MDBox sx={{ minWidth: 35 }}>
        <MDTypography variant="body2" color="text.secondary">{`${Math.round(
          props.value
        )}%`}</MDTypography>
      </MDBox>
    </MDBox>
  );
}

LinearProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number.isRequired,
};

function Dashboard() {
  const ID_COMPLETE = 2;
  const ID_UNCOMPLETE = 1;
  const ID_BOSUNG = 3;
  const dicHoSo = {
    complete: "hoanThanh",
    uncomplete: "chuaHoanThanh",
    refuse: "tuchoi",
    expired: "hethan",
    completePro: "hoanThanhTinh",
    uncompletePro: "chuaHoanThanhTinh",
  };
  const location = useLocation();
  const axiosPrivateInstance = useAxiosPrivate();
  const { user } = useAuth();
  const navigate = useNavigate();
  const setAlert = useSetRecoilState(AlertState);
  const [open, setOpen] = useState(false);
  const [controller, dispatch] = useMaterialUIController();
  const {
    miniSidenav,
    transparentNavbar,
    fixedNavbar,
    openConfigurator,
    darkMode,
  } = controller;
  const [chartData, setChartData] = useState({
    chuThe: [],
    sanPham: [],
    hangSanPham: [],
  });
  const [infoData, setInfoData] = useState();
  const [infoSelectYear, setInfoSelectYear] = useState(new Date());
  const [labelYearsChart, setLabelYearsChart] = useState([]);
  const [inforDataTotal, setInforDataTotal] = useState();

  //hồ sơ
  const [yearDoc, setYearDoc] = useState(new Date());
  const [dataDoc, setDataDoc] = useState({
    [dicHoSo.expired]: 0,
    [dicHoSo.complete]: 0,
    [dicHoSo.refuse]: 0,
    [dicHoSo.uncomplete]: 0,
    [dicHoSo.completePro]: 0,
    [dicHoSo.uncompletePro]: 0,
  });

  //thongkesanpham_hang_huyen_nam
  const [yearHang, setYearHang] = useState(new Date());
  const [dataHangHuyen, setDataHangHuyen] = useState([]);
  const [loadingHangHuyen, setLoadingHangHuyen] = useState(false);

  //countTotalNoti
  const setCountNotificationState = useSetRecoilState(CountNotificationState);

  useEffect(() => {
    return () => {
      setDataDoc({
        [dicHoSo.expired]: 0,
        [dicHoSo.complete]: 0,
        [dicHoSo.refuse]: 0,
        [dicHoSo.uncomplete]: 0,
        [dicHoSo.completePro]: 0,
        [dicHoSo.uncompletePro]: 0,
      });
    };
  }, []);
  //Kiểm tra nhóm người dùng với id Group
  const checkGroupUser = (user, idGroup) => {
    let check = false;
    if (user && user.id) {
      if (user?.group?.find((item) => item?.id == idGroup)) {
        check = true;
      }
    }
    return check;
  };
  const isSubset = (A, B) => {
    return A.every((element) => B.includes(element));
  };
  const checkArrayGroupUser = (user, ArrayIdGroup) => {
    let check = false;
    if (user && user.id) {
      check = isSubset(ArrayIdGroup, user);
    }
    return check;
  };

  //kiểm tra đang đăng nhập với nhóm chủ thể
  const isOwner = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_CHUTHE);
  }, [user]);

  //kiểm tra đang đăng nhập với nhóm hội đồng = 6
  const isHoiDong = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_HOIDONG);
  }, [user]);

  //Kiểm tra nhóm người dùng là 1
  const isGroupNumberOne = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_NUMBER_ONE);
  }, [user]);
  //Kiểm tra nhóm người dùng là 7
  const isGroupNumberSeven = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_NUMBER_SEVEN);
  }, [user]);
  //Kiểm tra nhóm người dùng là 9
  const isGroupNumberNine = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_CAPTINH);
  }, [user]);
  const isHoiDongCapTinh = useMemo(() => {
    return checkArrayGroupUser([6, 9], user);
  }, [user]);
  //Kiểm tra nhóm người dùng là 8 - phường xã
  const isGroupNumberEight = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_PHUONGXA);
  }, [user]);

  //data của hồ sơ - đã hoàn thành, chưa hoàn thành
  const getDataDoc = async ({ trangthai, nam, user, key }) => {
    const isOwner = checkGroupUser(user, ID_GROUP_CHUTHE); //5
    const isGroupSeven = checkGroupUser(user, ID_GROUP_NUMBER_SEVEN); //7
    const isGroupHoiDong = checkGroupUser(user, ID_GROUP_HOIDONG); //6
    const isGroupCapPX = checkGroupUser(user, ID_GROUP_PHUONGXA); //8
    const isGroupOne = checkGroupUser(user, ID_GROUP_NUMBER_ONE); //1
    if (
      isOwner ||
      isGroupSeven ||
      isGroupHoiDong ||
      isGroupCapPX ||
      isGroupOne
    ) {
      const body = {
        trangthai: trangthai,
        nam: nam && dayjs(nam)?.isValid() ? dayjs(nam)?.get("year") : undefined,
        maquan: isGroupSeven ? user?.maquan : undefined,
        maphuong: isGroupCapPX ? user?.maphuong : undefined,
        username: isOwner ? user?.username : undefined,
        hoidong: isGroupHoiDong
          ? user?.hoidong?.map((item) => item?.id)
          : undefined,
        thanhvien: isGroupHoiDong ? user?.thanhvien : undefined,
      };
      const queries = JsonTool.convertToQueryString(body);
      const urlAPI = isGroupHoiDong
        ? API_ROUTES.GETPHIEUDANGKY
        : API_ROUTES.PHIEUDANGKY;
      try {
        const response = await axiosPrivateInstance.get(urlAPI + "?" + queries);
        setDataDoc((prev) => ({
          ...prev,
          [key]: response.data?.totalRecord,
        }));
      } catch (error) {
        console.log(error);
        return;
      }
    }
  };
  const getDataDocProvince = async ({ trangthai, nam, user, key }) => {
    const isGroupOne = checkGroupUser(user, ID_GROUP_NUMBER_ONE);
    const isGroupHoiDong = checkGroupUser(user, ID_GROUP_HOIDONG);
    const isGroupNine = checkGroupUser(user, ID_GROUP_CAPTINH); //9
    if (isGroupNine || isGroupHoiDong || isGroupOne) {
      const body = {
        hoidong: isGroupHoiDong
          ? user?.hoidong?.map((item) => item?.id)
          : undefined,
        thanhvien: isGroupHoiDong ? user?.thanhvien : undefined,
        trangthai: trangthai,
        nam: nam && dayjs(nam)?.isValid() ? dayjs(nam)?.get("year") : undefined,
        thanhvien: user?.thanhvien,
      };
      const queries = JsonTool.convertToQueryString(body);
      try {
        const response = await axiosPrivateInstance.get(
          API_ROUTES.PHIEUDANGKYCAPTINH + "?" + queries
        );
        setDataDoc((prev) => ({
          ...prev,
          [key]: response.data?.totalRecord,
        }));
      } catch (error) {
        console.log(error);
        return;
      }
    }
  };
  const getDataSanPham = async ({ user, key }) => {
    const isGroupCapPX = checkGroupUser(user, ID_GROUP_PHUONGXA); //8
    const isGroupOne = checkGroupUser(user, ID_GROUP_NUMBER_ONE); //1
    const isOwner = checkGroupUser(user, ID_GROUP_CHUTHE); //5
    const isGroupSeven = checkGroupUser(user, ID_GROUP_NUMBER_SEVEN); //7
    const isGroupHoiDong = checkGroupUser(user, ID_GROUP_HOIDONG); //6
    if (
      isOwner ||
      isGroupHoiDong ||
      isGroupOne ||
      isGroupSeven ||
      isGroupCapPX
    ) {
      const body = {
        expired: true,
        maquan: isGroupSeven || isGroupHoiDong ? user.maquan : undefined,
        maphuong: isGroupCapPX ? user.maphuong : undefined,
        username: isOwner ? user?.username : undefined,
      };
      const queries = JsonTool.convertToQueryString(body);
      try {
        const response = await axiosPrivateInstance.get(
          API_ROUTES.SANPHAM + "?" + queries
        );
        setDataDoc((prev) => ({
          ...prev,
          [key]: response.data?.totalRecord,
        }));
      } catch (error) {
        console.log(error);
        return;
      }
    }
  };
  useEffect(() => {
    const paramsHoanThanh = {
      trangthai: ID_COMPLETE,
      nam: yearDoc,
      user: user,
      key: dicHoSo.complete,
    };
    const paramsChuaHoanThanh = {
      trangthai: ID_UNCOMPLETE,
      nam: yearDoc,
      user: user,
      key: dicHoSo.uncomplete,
    };
    const paramsBoSung = {
      trangthai: ID_BOSUNG,
      nam: yearDoc,
      user: user,
      key: dicHoSo.refuse,
    };
    const paramsSanPham = {
      user: user,
      key: dicHoSo.expired,
    };
    const paramsHoanThanhTinh = {
      trangthai: ID_COMPLETE,
      nam: yearDoc,
      user: user,
      key: dicHoSo.completePro,
    };
    const paramsChuaHoanThanhTinh = {
      trangthai: ID_UNCOMPLETE,
      nam: yearDoc,
      user: user,
      key: dicHoSo.uncompletePro,
    };
    if (yearDoc && user && user.id) {
      getDataDoc(paramsHoanThanh);
      getDataDoc(paramsChuaHoanThanh);
      getDataDoc(paramsBoSung);
      getDataSanPham(paramsSanPham);
      getDataDocProvince(paramsHoanThanhTinh);
      getDataDocProvince(paramsChuaHoanThanhTinh);
    }
  }, [yearDoc, user]);

  //lấy tổng số thông báo
  useEffect(() => {
    const isOwner = checkGroupUser(user, ID_GROUP_CHUTHE);
    const isGroupSeven = checkGroupUser(user, ID_GROUP_NUMBER_SEVEN);
    const isGroupPhuong = checkGroupUser(user, ID_GROUP_PHUONGXA);
    const isGroupOne = checkGroupUser(user, ID_GROUP_NUMBER_ONE);
    const isGroupTinh = checkGroupUser(user, ID_GROUP_CAPTINH);
    const isGroupHoiDong = checkGroupUser(user, ID_GROUP_HOIDONG);
    if (isOwner || isGroupSeven || isGroupPhuong || isGroupOne || isGroupTinh) {
      const getCountTotalNoti = (user) => {
        axiosPrivateInstance
          .get(API_ROUTES.DASHBOARD, {
            params: {
              username: isOwner && user ? user?.username : undefined,
              maquan: isGroupSeven ? user?.maquan : undefined,
              maphuong: isGroupPhuong ? user?.maphuong : undefined,
            },
          })
          .then((response) => {
            setCountNotificationState(response.data?.data.thongbao);
          })
          .catch((error) => {
            console.log(error);
            return;
          });
      };
      if (user && user.id) {
        if (
          isOwner ||
          isGroupSeven ||
          isGroupPhuong ||
          isGroupOne ||
          isGroupTinh
        ) {
          getCountTotalNoti(user);
          return;
        } else if (isGroupHoiDong) {
          setCountNotificationState(0);
        }
      }
    }
  }, [user]);

  useEffect(() => {
    setOpen(location.state && location.state.successMessage ? true : false);
    setHomePage(dispatch, false);

    const nowYear = new Date().getFullYear();
    let listYear = [];
    for (let i = -7; i < 3; i++) {
      listYear.push(nowYear + i);
    }
    setLabelYearsChart(listYear);
    const findValueByYear = (arr, year) => {
      const foundItem = arr.find((item) => item.nam === year);
      return foundItem ? foundItem.so_luong : 0;
    };
    const getDataDashboard = async () => {
      try {
        const response = await axiosPrivateInstance.get(API_ROUTES.DASHBOARD);
        const data = response.data?.data;
        const listCT = listYear.map((nam) =>
          findValueByYear(data?.chuthe_bieudo, nam)
        );
        const listSP = listYear.map((nam) =>
          findValueByYear(data?.sanpham_bieudo, nam)
        );

        let listHang = {
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
        };
        data?.hang_sanphamocop?.forEach((level) => {
          listHang[level?.hang] = level?.total;
        });
        setChartData((prev) => ({
          ...prev,
          chuThe: listCT,
          sanPham: listSP,
          hangSanPham: Object.values(listHang),
        }));
        setInforDataTotal({
          chuThe: data?.chuthe_tong,
          sanPham: data?.sanphamocop_tong,
        });
      } catch (error) {
        console.log(error);
        return;
      }
    };
    getDataDashboard();
  }, []);

  useEffect(() => {
    const getDataInfoByYear = async (year) => {
      try {
        const response = await axiosPrivateInstance.get(API_ROUTES.DASHBOARD, {
          params: {
            nam:
              year && dayjs(year)?.isValid()
                ? dayjs(year)?.get("year")
                : undefined,
          },
        });
        setInfoData(response.data?.data?.thongke_nam);
      } catch (error) {
        return;
      }
    };
    getDataInfoByYear(infoSelectYear);
  }, [infoSelectYear]);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  const handleChangeDate = (value) => {
    setInfoSelectYear(value);
  };
  const handleChangeDateDoc = (value) => {
    setYearDoc(value);
  };
  const handleToHoSoHoanThanh = () => {
    const params = new URLSearchParams({
      trangthai: 2,
      nam:
        yearDoc && dayjs(yearDoc)?.isValid() ? dayjs(yearDoc)?.get("year") : "",
    });
    navigate(
      `/quanlysanphamocop/${PermissionMenuKey.phieudangky}?${params.toString()}`
    );
  };
  const handleToHoSoThamDinh = () => {
    const params = new URLSearchParams({
      trangthai: 1,
      nam:
        yearDoc && dayjs(yearDoc)?.isValid() ? dayjs(yearDoc)?.get("year") : "",
    });
    navigate(
      `/quanlysanphamocop/${PermissionMenuKey.phieudangky}?${params.toString()}`
    );
  };
  const handleToHoSoBoSung = () => {
    const params = new URLSearchParams({
      trangthai: 3,
      nam:
        yearDoc && dayjs(yearDoc)?.isValid() ? dayjs(yearDoc)?.get("year") : "",
    });
    navigate(
      `/quanlysanphamocop/${PermissionMenuKey.phieudangky}?${params.toString()}`
    );
  };
  const handleToSanphamHethan = () => {
    const params = new URLSearchParams({
      expired: true,
    });
    if (isOwner && user) {
      params.append("username", user.username);
    }
    navigate(
      `/quanlysanphamocop/${PermissionMenuKey.sanpham}?${params.toString()}`
    );
  };
  //hồ sơ tỉnh
  const handleToHoSoHoanThanhTinh = () => {
    const params = new URLSearchParams({
      trangthai: 2,
      nam:
        yearDoc && dayjs(yearDoc)?.isValid() ? dayjs(yearDoc)?.get("year") : "",
    });
    navigate(
      `/chamdiemcaptinh/${
        PermissionMenuKey.hosodangkycaptinh
      }?${params.toString()}`
    );
  };
  const handleToHoSoChuaHoaThanhTinh = () => {
    const params = new URLSearchParams({
      trangthai: 1,
      nam:
        yearDoc && dayjs(yearDoc)?.isValid() ? dayjs(yearDoc)?.get("year") : "",
    });
    navigate(
      `/chamdiemcaptinh/${
        PermissionMenuKey.hosodangkycaptinh
      }?${params.toString()}`
    );
  };

  //thongke_hang_sanpham_huyen
  const handleChangeDateYearHang = (value) => {
    setYearHang(value);
  };
  const getDataHangHuyen = ({ nam, user }) => {
    setLoadingHangHuyen(true);
    const isOwner = checkGroupUser(user, ID_GROUP_CHUTHE);
    const isGroupSeven = checkGroupUser(user, ID_GROUP_NUMBER_SEVEN);
    const isGroupHoiDong = checkGroupUser(user, ID_GROUP_HOIDONG);
    axiosPrivateInstance
      .get(API_ROUTES.THONGKESANPHAMDONVI, {
        params: {
          nam:
            nam && dayjs(nam)?.isValid() ? dayjs(nam)?.get("year") : undefined,
          maquan:
            (isOwner || isGroupSeven || isGroupHoiDong) && user?.maquan
              ? user.maquan
              : undefined,
        },
      })
      .then((res) => {
        setDataHangHuyen(res.data?.data?.huyen);
      })
      .catch((error) => {
        setAlert({
          alert: true,
          message: error?.message || "Lỗi!",
          type: "error",
        });
        return;
      })
      .finally(() => {
        setLoadingHangHuyen(false);
      });
  };

  useEffect(() => {
    if (yearHang && user && user.id) {
      getDataHangHuyen({ nam: yearHang, user: user });
    }
  }, [yearHang, user]);
  return (
    <>
      {location.state && location.state.successMessage && (
        <Snackbar
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={open}
          onClose={handleClose}
        >
          <Alert onClose={handleClose} severity="success">
            {location.state.successMessage}
          </Alert>
        </Snackbar>
      )}
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox
          py={2}
          mb={0}
          // mr={{ xs: 0, xl: 8 }}
          sx={{
            borderRadius: "0.5rem",
            boxShadow: "5px 5px 10px 0px rgba(159,159,207,1)",
            marginBottom: "0.75rem",
          }}
        >
          <Grid
            container
            spacing={2}
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          >
            <Grid item xs={12} md={12} lg={12}>
              <MDTypography
                color={darkMode ? "light" : "dark"}
                variant="h6"
                style={{ paddingLeft: "1rem" }}
              >
                HỒ SƠ
              </MDTypography>
            </Grid>
          </Grid>
        </MDBox>
        <Card style={{ marginBottom: "2rem", padding: "1.5rem" }}>
          <Grid container spacing={3}>
            <Grid
              item
              xs={12}
              sx={{ display: "flex", justifyContent: "flex-end" }}
            >
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  value={yearDoc ? dayjs(yearDoc) : null}
                  views={["year"]}
                  onChange={handleChangeDateDoc}
                  slotProps={{
                    textField: {
                      InputLabelProps: { shrink: true },
                      placeholder: "---Chọn năm---",
                      fullWidth: true,
                      inputProps: {
                        readOnly: true,
                      },
                    },
                  }}
                  label="Năm"
                  sx={{
                    ".MuiInputLabel-shrink": {
                      fontSize: "0.875rem",
                      lineHeight: "1.6",
                    },
                    maxWidth: "10rem",
                  }}
                />
              </LocalizationProvider>
            </Grid>
            {(isOwner ||
              isHoiDong ||
              isGroupNumberOne ||
              isGroupNumberSeven ||
              isGroupNumberEight) && (
              <>
                <Grid item xs={12} md={6} lg={3}>
                  <CardInforDoc
                    title={"Sản phẩm hết hạn"}
                    number={dataDoc[dicHoSo.expired]}
                    onDetail={handleToSanphamHethan}
                    bgColor={"#9c27b02b"}
                    icon="category"
                    color="primary"
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                  <CardInforDoc
                    title={"Hồ sơ đã hoàn thành"}
                    number={dataDoc[dicHoSo.complete]}
                    onDetail={handleToHoSoHoanThanh}
                    bgColor={"#bff4c2"}
                    icon="inventory"
                    color="success"
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                  <CardInforDoc
                    title={"Hồ sơ cần thẩm định"}
                    number={dataDoc[dicHoSo.uncomplete]}
                    onDetail={handleToHoSoThamDinh}
                    bgColor={"#fde8cc"}
                    icon="pending_actions"
                    color="warning"
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                  <CardInforDoc
                    title={"Hồ sơ trả, bổ sung"}
                    number={dataDoc[dicHoSo.refuse]}
                    onDetail={handleToHoSoBoSung}
                    bgColor={"#fdc8c7"}
                    icon="pending_actions"
                    color="error"
                  />
                </Grid>
              </>
            )}

            {/* cấp tỉnh */}
            {(isGroupNumberNine || isHoiDongCapTinh || isGroupNumberOne) && (
              <>
                <Grid item xs={12} md={6} lg={6}>
                  <CardInforDoc
                    title={"Hồ sơ cấp tỉnh đã hoàn thành"}
                    number={dataDoc[dicHoSo.completePro]}
                    onDetail={handleToHoSoHoanThanhTinh}
                    bgColor={"#d1e8ff"}
                    icon="pending_actions"
                    color="info"
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <CardInforDoc
                    title={"Hồ sơ cấp tỉnh chưa hoàn thành"}
                    number={dataDoc[dicHoSo.uncompletePro]}
                    onDetail={handleToHoSoChuaHoaThanhTinh}
                    bgColor={"#f6e4ff"}
                    icon="pending_actions"
                    color="purpleLight"
                  />
                </Grid>
              </>
            )}
          </Grid>
        </Card>
        <MDBox
          py={2}
          mb={0}
          // mr={{ xs: 0, xl: 8 }}
          sx={{
            borderRadius: "0.5rem",
            boxShadow: "5px 5px 10px 0px rgba(159,159,207,1)",
            marginBottom: "0.75rem",
          }}
        >
          <Grid
            container
            spacing={2}
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          >
            <Grid item xs={12} md={12} lg={12}>
              <MDTypography
                color={darkMode ? "light" : "dark"}
                variant="h6"
                style={{ paddingLeft: "1rem" }}
              >
                THỐNG KÊ
              </MDTypography>
            </Grid>
          </Grid>
        </MDBox>
        <Grid container columnSpacing={2}>
          <Grid item xs={12} md={6} lg={6}>
            <Card style={{ marginBottom: "2rem" }}>
              <Grid container spacing={1} p={"1rem"}>
                <Grid item xs={12}>
                  <MDTypography variant="h6" fontWeight="medium">
                    Thống kê tổng
                  </MDTypography>
                </Grid>
              </Grid>
              <Grid container spacing={2} p={"1rem"} marginTop={"-40px"}>
                <Grid container spacing={3} m={"0.5rem"}>
                  <Grid item xs={6}>
                    <DefaultInfoCard
                      icon="home_repair_service"
                      title="Chủ thể"
                      value={inforDataTotal?.chuThe?.toString() || ""}
                      color="warning"
                      bgColor="#fde8cc"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <DefaultInfoCard
                      icon="inventory_2"
                      title="Sản phẩm OCOP"
                      color="success"
                      value={inforDataTotal?.sanPham?.toString() || ""}
                      bgColor="#bff4c2"
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Card>
          </Grid>
          <Grid item xs={12} md={6} lg={6}>
            <Card style={{ marginBottom: "2rem" }}>
              <Grid container spacing={1} p={"0.95rem"}>
                <Grid item xs={6}>
                  <MDTypography variant="h6" fontWeight="medium">
                    Thống kê theo năm
                  </MDTypography>
                </Grid>
                <Grid item xs={6}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      value={infoSelectYear ? dayjs(infoSelectYear) : null}
                      views={["year"]}
                      onChange={handleChangeDate}
                      slotProps={{
                        textField: {
                          InputLabelProps: { shrink: true },
                          placeholder: "---Chọn năm---",
                          fullWidth: true,
                          inputProps: {
                            readOnly: true,
                          },
                        },
                      }}
                      label="Năm"
                      sx={{
                        ".MuiInputLabel-shrink": {
                          fontSize: "0.875rem",
                          lineHeight: "1.6",
                        },
                      }}
                    />
                  </LocalizationProvider>
                </Grid>
              </Grid>
              <Grid container spacing={2} p={"1rem"} marginTop={"-40px"}>
                <Grid container rowSpacing={1} columnSpacing={3} m={"0.5rem"}>
                  <Grid item xs={6}>
                    <DefaultInfoCard
                      icon="home_repair_service"
                      title="Chủ thể"
                      value={infoData?.chuthe?.toString() || ""}
                      color="primary"
                      bgColor="#ec407a26"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <DefaultInfoCard
                      icon="inventory_2"
                      title="Sản phẩm OCOP"
                      value={infoData?.sanphamocop?.toString() || ""}
                      bgColor="#49a3f121"
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Card>
          </Grid>
        </Grid>

        <Grid
          container
          columnSpacing={2}
          rowSpacing={3}
          sx={{ marginBottom: "36px" }}
        >
          <Grid item xs={12} md={6} lg={6}>
            <VerticalBarChart
              icon={{ color: "warning", component: "location_city" }}
              title="Biểu đồ chủ thể"
              description="Thống kê chủ thể"
              chart={{
                labels: labelYearsChart || [],
                datasets: [
                  {
                    label: "Tổng chủ thể",
                    color: "warning",
                    data: chartData.chuThe || [],
                  },
                ],
              }}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={6}>
            <VerticalBarChart
              icon={{ color: "success", component: "leaderboard" }}
              title="Biểu đồ sản phẩm OCOP"
              description="Thống kê sản phẩm OCOP"
              chart={{
                labels: labelYearsChart || [],
                datasets: [
                  {
                    label: "Tổng sản phẩm",
                    color: "success",
                    data: chartData.sanPham || [],
                  },
                ],
              }}
            />
          </Grid>

          <Grid item xs={12} md={12} lg={12}>
            <PieChart
              icon={{ color: "info", component: "pie_chart" }}
              title="Hạng sản phẩm OCOP"
              description="Tỉ lệ hạng sao sản phẩm OCOP"
              chart={{
                labels: ["1 sao", "2 sao", "3 sao", "4 sao", "5 sao"],
                datasets: {
                  label: "Sản phẩm",
                  backgroundColors: colorDefault,
                  data: chartData.hangSanPham || [],
                },
              }}
            />
          </Grid>
          <Grid
            item
            xs={12}
            md={12}
            lg={12}
            minHeight={dataHangHuyen?.length > 5 ? "28rem" : "auto"}
          >
            <DataTable
              fullWidth
              loading={loadingHangHuyen}
              table={{
                columns: [
                  {
                    Header: "STT",
                    width: "5%",
                    align: "center",
                    originNumber: true,
                  },
                  {
                    Header: "Huyện",
                    accessor: "ten",
                    width: "21%",
                  },
                  {
                    Header: "Chủ thể",
                    accessor: "chuthe_tong",
                    width: "12%",
                    Cell: ({ value }) => {
                      return typeof value == "number"
                        ? parseFloat(value).toLocaleString("en-US")
                        : value;
                    },
                    muiTableBodyCellProps: {
                      align: "right",
                    },
                  },
                  {
                    Header: "Sản phẩm",
                    accessor: "sanpham_tong",
                    width: "12%",
                    Cell: ({ value }) => {
                      return typeof value == "number"
                        ? parseFloat(value).toLocaleString("en-US")
                        : value;
                    },
                    muiTableBodyCellProps: {
                      align: "right",
                    },
                  },
                  {
                    Header: "Hạng 1",
                    accessor: "hang1",
                    width: "10%",
                    Cell: ({ value }) => {
                      return typeof value == "number"
                        ? parseFloat(value).toLocaleString("en-US")
                        : value;
                    },
                    muiTableBodyCellProps: {
                      align: "right",
                    },
                  },

                  {
                    Header: "Hạng 2",
                    accessor: "hang2",
                    width: "10%",
                    Cell: ({ value }) => {
                      return typeof value == "number"
                        ? parseFloat(value).toLocaleString("en-US")
                        : value;
                    },
                    muiTableBodyCellProps: {
                      align: "right",
                    },
                  },
                  {
                    Header: "Hạng 3",
                    accessor: "hang3",
                    width: "10%",
                    Cell: ({ value }) => {
                      return typeof value == "number"
                        ? parseFloat(value).toLocaleString("en-US")
                        : value;
                    },
                    muiTableBodyCellProps: {
                      align: "right",
                    },
                  },
                  {
                    Header: "Hạng 4",
                    accessor: "hang4",
                    width: "10%",
                    Cell: ({ value }) => {
                      return typeof value == "number"
                        ? parseFloat(value).toLocaleString("en-US")
                        : value;
                    },
                    muiTableBodyCellProps: {
                      align: "right",
                    },
                  },
                  {
                    Header: "Hạng 5",
                    accessor: "hang5",
                    width: "10%",
                    Cell: ({ value }) => {
                      return typeof value == "number"
                        ? parseFloat(value).toLocaleString("en-US")
                        : value;
                    },
                    muiTableBodyCellProps: {
                      align: "right",
                    },
                  },
                ],
                rows: dataHangHuyen,
              }}
              // title={"Thống kê sản phẩm của từng huyện theo hạng"}
              nonePerPage={true}
              showTotalEntries={false}
              header={
                <Grid container spacing={1} p={"1rem"}>
                  <Grid item xs={7} md={9} lg={10}>
                    <Typography variant="h6">
                      Thống kê sản phẩm của từng huyện theo hạng
                    </Typography>
                  </Grid>
                  <Grid item xs={5} md={3} lg={2}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        value={yearHang ? dayjs(yearHang) : null}
                        views={["year"]}
                        onChange={handleChangeDateYearHang}
                        slotProps={{
                          textField: {
                            InputLabelProps: { shrink: true },
                            placeholder: "---Chọn năm---",
                            fullWidth: true,
                            inputProps: {
                              readOnly: true,
                            },
                          },
                        }}
                        label="Năm"
                        sx={{
                          ".MuiInputLabel-shrink": {
                            fontSize: "0.875rem",
                            lineHeight: "1.6",
                          },
                        }}
                      />
                    </LocalizationProvider>
                  </Grid>
                </Grid>
              }
            />
          </Grid>
        </Grid>
        <Footer />
      </DashboardLayout>
    </>
  );
}

export default Dashboard;
